/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_TitleInputs */

const en_directory_taxonomy_use_cases_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with the work you need to do`)
};

const zh_directory_taxonomy_use_cases_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从你需要完成的工作开始`)
};

/**
* | output |
* | --- |
* | "Start with the work you need to do" |
*
* @param {Directory_Taxonomy_Use_Cases_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_title = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_title(inputs)
	return zh_directory_taxonomy_use_cases_title(inputs)
});
export { directory_taxonomy_use_cases_title as "directory.taxonomy.use-cases.title" }